<template>
  <b-row>
    <b-col v-if="!noDrag">
      <h4 v-if="showHeader">อัพโหลดเอกสาร</h4>
      <p v-if="forJobCreate">หากต้องการราคาสำหรับหลายเส้นทาง คุณสามารถอัพโหลดฟอร์มเสนอราคาได้ที่นี่ หรือถ้าหากไม่มี สามารถดาวโหลดตัวอย่างแบบฟอร์มเสนอราคาจาก Logisty ได้ <b-link :href="templateUrl" target="_blank">ที่นี่</b-link></p>
      <vue-dropzone v-if="show"
        class="m-2"
        ref="myVueDropzone"
        :id="refId"
        :options="dropzoneOptions"
        @vdropzone-processing="processing"
        @vdropzone-removed-file="removed"
        :destroyDropzone="false"
        @vdropzone-success="success"
        @vdropzone-error="doError"
        @vdropzone-queue-complete="allComplete"
        @vdropzone-file-added="added"
        :useCustomSlot=true
      >
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">คลิกเพื่ออัพโหลดไฟล์</h3>

      </div>
      </vue-dropzone>
      <!-- <b-button v-on:click="doUpload" variant="primary">อัพโหลดไฟล์</b-button> -->
    </b-col>
    <b-col v-else>
      <h4 v-if="showHeader">อัพโหลดเอกสาร</h4>
      <p v-if="forJobCreate">หากต้องการราคาสำหรับหลายเส้นทาง คุณสามารถอัพโหลดฟอร์มเสนอราคาได้ที่นี่ หรือถ้าหากไม่มี สามารถดาวโหลดตัวอย่างแบบฟอร์มเสนอราคาจาก Logisty ได้ <b-link :href="templateUrl" target="_blank">ที่นี่</b-link></p>
      <vue-dropzone v-if="show"
        class="m-2"
        ref="myVueDropzone"
        id="dropzone-nodrag"
        :options="dropzoneOptions"
        @vdropzone-processing="processing"
        @vdropzone-removed-file="removed"
        :destroyDropzone="false"
        @vdropzone-success="success"
        @vdropzone-error="doError"
        @vdropzone-queue-complete="allComplete"
        @vdropzone-file-added="added"
        :useCustomSlot=true
      >
      <div class="dropzone-custom-content">
        <div class="subtitle">คลิกเพื่ออัพโหลดไฟล์</div>
      </div>
      </vue-dropzone>
      <!-- <b-button v-on:click="doUpload" variant="primary">อัพโหลดไฟล์</b-button> -->
    </b-col>
  </b-row>
</template>

<style>
#dropzone-nodrag {
  background-color: #1c4862;
  color: white;
  width: 50%;
  max-width: 200px;
  min-height: 0px !important;
  margin: auto !important;
}
#dropzone-nodrag .dz-preview {
    display: none;
  }
#dropzone-nodrag .dz-message {
    margin: 0;
  }
</style>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import HttpFile from '../services/http/File'

export default {
  name: 'UploadFile',
  props: {
    docType: {
      type: String,
      required: true
    },
    refId: {
      type: String,
      default: 'dropzone',
      required: false
    },
    queueOption: {
      type: Boolean,
      default: true,
      required: false
    },
    showHeader: {
      type: Boolean,
      default: true,
      required: false
    },
    keepCompleted: {
      type: Boolean,
      default: false,
      required: false
    },
    forJobCreate: {
      type: Boolean,
      default: false,
      required: false
    },
    noDrag: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      dropzoneOptions: {
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME,
        headers: {
          'authorization': 'Bearer ' + window.$cookies.get('token')
        },
        maxFilesize: 10,
        addRemoveLinks: true,
        autoProcessQueue: this.queueOption,
        acceptedFiles: 'text/plain,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      show: true,
      objectRefId: null,
      complete: false,
      fileNum: 0,
      templateUrl: process.env.VUE_APP_QUOTE_TEMPLATE_URL,
      qProcressed: false
    }
  },
  mounted () {
    this.objectRefId = this.refId
    Window.Event.$on('doUploadQueue-' + this.docType, (value) => {
      this.objectRefId = value
      this.doUpload()
    })
  },
  beforeDestroy () {
    Window.Event.$off('doUploadQueue-' + this.docType)
  },
  methods: {
    processing (file) {
      // console.log(file)
      // console.log(this.$refs.myVueDropzone)
      var httpDoc = new HttpFile(this.docType, this.objectRefId)
      // console.log(httpDoc.getUrlImg())
      // console.log(httpDoc.getUrlPdf())
      this.$refs.myVueDropzone.setOption('url', httpDoc.getUploadUrl())
    },
    async removed (file) {
      // console.log(file.xhr)
      // console.log(file.xhr.status)
      // var responsive
      // if (file.status === 'error') {
      //   return
      // }
      // var xhr = file.xhr
      // var status = xhr.status
      // if (status == 200) {
      //   // do delete from server
      //   var response = JSON.parse(xhr.response)
      //   var httpDoc = new HttpDoc(this.docType, this.refId)
      //   try {
      //     await httpDoc.deleteDoc(response.data)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
      this.fileNum--
      if (this.fileNum < 0) {
        this.fileNum = 0
      }
    },
    success (file) {
      if (this.queueOption) {
        this.makeToast('success', file.name, 'อัพโหลดสำเร็จ')
      }
      if (!this.keepCompleted) {
        this.$refs.myVueDropzone.removeFile(file)
      }

      if (this.docType === 'carrier-quote') {
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'send_quote',
            quote_id: this.refId
          })
        }
      }
    },
    doError (file, message) {
      this.makeToast('danger', file.name, message)
      this.$refs.myVueDropzone.removeFile(file)
    },
    makeToast (variant = 'success', title = '', content = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    doUpload () {
      // console.log(this.refId)
      this.qProcressed = true
      this.$refs.myVueDropzone.processQueue()
    },
    allComplete () {
      Window.Event.$emit('reloadFile-' + this.docType)
      if (this.queueOption === false && this.qProcressed) {
        this.complete = true
      }
    },
    added () {
      this.fileNum++
    }
  }
}
</script>
